import React, { useEffect, useState } from 'react'
import moment from "moment"
import { ReactComponent as BackArrow } from "./../../back-arrow.svg"
import { ReactComponent as MoreElipsis } from "./../../more-elipsis.svg"
import { ReactComponent as CopyIcon } from "./../../copy-link-icon.svg"
import { ReactComponent as DeleteIcon } from "./../../delete-icon.svg"
import { ReactComponent as ListIcon } from "../../../../../assets/svg/static-assets/grid.svg"
import { ReactComponent as GridIcon } from "../../../../../assets/svg/static-assets/list.svg"
import { ReactComponent as JsonIcon } from "../../../../../assets/svg/jsonAssetsIcon.svg";
import { useHistory, useParams } from 'react-router-dom';
import { Popover } from '@headlessui/react'
import { FiLink2, FiTrash2 } from "react-icons/fi";
import { ReactComponent as SearchIcon } from "./../../assets/search-icon.svg"
import "./style.scss";
import { useToast } from '../../../../../helpers/commonFunction';
import { Http } from '../../../../../helpers/axois';
import { useDispatch, useSelector } from 'react-redux';
import { AppState, RootState } from '../../../../../stateManager/store';
import { fetchAllStaticAssetsByFiletype, createNewJsonAsset, deleteJsonAssetById } from '../../../../../stateManager/store/static-assets/action';
import { Icon, Input, Spin, Table } from 'antd';
import { Modal } from '../../../../../helpers/commonUi'
import { FormatBytes } from '../../../../../helpers/util'

const ADD_NEW_BTN = "+ New";
const PAGE_TITLE = "JSON"
const PAGE_SUBTITLE = "View, upload or remove json from assets"



export const JSONFolder = () => {
  const history = useHistory();
  const dispatch = useDispatch();
  const { SuccessToast, ErrorToast } = useToast();
  const params: { appId: string } = useParams();
  const jsonFiles = useSelector((state: RootState) => state.staticAssets.json || {})
  const orgId = useSelector((state: AppState) => state.org.selectedOrg.id);
  const [selectedJsonFile, setSelectedJsonFile] = useState({
    name: "",
    id: ""
  })
  const [isGridLayout, setGridLayout] = useState(true)
  const { selectedOrg } = useSelector((state: AppState) => state.org)
  const loggedInUserId = useSelector((state: any) => {
    return state.user.data.user.id
  })
  const orgPermissions: any = useSelector((state: AppState) => {
    return state.org.orgPermissions
  }, (oldPermissions: any, newPermissions: any) => JSON.stringify(oldPermissions) === JSON.stringify(newPermissions))
  const [searchValue, setSearchValue] = useState("")
  const [filesList, setFilesList] = useState(jsonFiles)
  const [deleteModalVisibile, setDeleteModalVisible] = useState(false)
  const [modalLoading, setModalLoading] = useState(false)
  const [loading, setLoading] = useState(false)
  const [uploadLoading,setUploadLoading]=useState(false)
  const handleBackArrowClick = () => {
    history.goBack();
  }
  useEffect(() => {
    setFilesList(jsonFiles)
  }, [jsonFiles])

  const columns = [
    {
      title: "Name",
      dataIndex: "filename",
      key: "filename",
      width: "50%"
    },
    {
      title: "File Size",
      dataIndex: "size",
      key: "size",
      width: "20%"
    },
    {
      title: "Last Modified Date",
      dataIndex: "updated_at",
      key: "updated_at",
      width: "20%"
    },
    {
      title: "Actions",
      key: "actions",
      render: (text: any, record: any) => (
        <div className="action">
          <span
            data-test-id="action_policy"
            title='Copy Json Link'
            className="action-icon edit-icon"
            onClick={e => {
              e.stopPropagation();
              handleJSONFileUrlCopy(record.id)
            }}
          >
            <FiLink2 style={{ transform: "rotate(135deg)" }} />
          </span>
          <span
            data-test-id="action_edit"
            title="Delete"
            className="action-icon delete-icon"
            onClick={e => {
              e.stopPropagation();
              setSelectedJsonFile({ id: record.id, name: record.filename })
              setDeleteModalVisible(true)
            }}
          >
            <FiTrash2 data-test-id="table" height='15px' width='15px' />
          </span>
        </div>
      )
    }
  ];

  const listView = Object.values(filesList).map((item: any) => {
    return {
      key: item.id,
      id: item.id,
      filename: item.filename,
      size: FormatBytes(item.size),
      updated_at: moment(item.updated_at).format("LL")
    }
  })

  const fetchJsonFiles = async () => {
    setLoading(true);
    try {
      const payload = {
        "appId": params.appId,
        "filetype": "json",
        orgId
      };
      await dispatch(fetchAllStaticAssetsByFiletype(payload));
    } catch (error) {
      console.error("Error fetching JSON files:", error);
    } finally {
      setLoading(false);
    }
  };

  const handleJsonUpload = async (e: React.ChangeEvent<HTMLInputElement>) => {
    try {
      setUploadLoading(true)
      if (
        (!orgPermissions?.includes("staticAsset.Create") ||
          !orgPermissions?.includes("staticAsset.View") ||
          !orgPermissions.includes("app.View")) &&
        loggedInUserId !== selectedOrg?.owner
      ) {
        ErrorToast("Not Authorized: Please request owner of this organization to provide access");
        return;
      }

      if (e.target.files?.length) {
        const file: File = e.target.files[0];
        const { type, name, size } = file;

        if (type === "application/json") {
          const [fileName, ext] = name.split(".");
          const updated_filename = `${fileName.replace(/[ ()]/g, '')}_${Date.now()}.${ext}`;

          const payload = {
            filetype: type,
            filename: updated_filename,
            orgId,
            appId: params.appId
          };

          const resp: any = await Http.post("/static-asset/get-upload-url", payload, {
            headers: {
              "Content-Type": "application/json"
            }
          }).toPromise();

          if (resp.ok) {
            await Http.put(resp.url, file, {
              headers: {
                "Content-Type": type
              }
            }).toPromise();

            try {
              const data: any = await Http.post("/static-asset/create", {
                appId: params.appId,
                filename: updated_filename,
                filetype: "json",
                url: resp.filePath,
                size,
                orgId
              }).toPromise();
              dispatch(createNewJsonAsset(data))

              SuccessToast("JSON file uploaded successfully");
            } catch (e) {
              if (e === "Forbidden") {
                ErrorToast("Not Authorized: Please request owner of this organization to provide access");
              }
            }
          }
        } else {
          ErrorToast("Please upload a valid JSON file");
        }
      }
    } catch (error) {
      console.error(error);
      ErrorToast("Error uploading JSON file");
    } finally {
      setUploadLoading(false)
    }
  };

  const handleJSONFileUrlCopy = (id: string) => {
    const url = jsonFiles[id].url
    navigator.clipboard.writeText(url);
    SuccessToast("URL copied to clipboard")
  }

  const handleJSONFileDelete = async (filename: string, id: string) => {
    setModalLoading(true)
    const endpoint = `/static-asset`;
    try {
      const payload: any = {
        appId: params.appId,
        orgId,
        id: id || selectedJsonFile.id,
        filename: filename || selectedJsonFile.name,
      };
      const data: any = await Http.put(endpoint, payload).toPromise();
      if (data.ok) {
        dispatch(deleteJsonAssetById({ id }))
        SuccessToast('Successfully deleted file');
        setDeleteModalVisible(false)
      } else {
        throw new Error("Failed to delete the file")
      }
    } catch (err) {
      if (err instanceof Error) {
        const msg = err.message || 'Failed to delete file';
        ErrorToast(msg);
      } else {
        ErrorToast("Failed to delete file");
      }
    } finally {
      setModalLoading(false)
    }
  }

  const handleLayoutSwitch = (e: any) => {
    e.stopPropagation();

    setGridLayout(prev => !prev)
  }

  useEffect(() => {
    fetchJsonFiles();
  }, [])
  const filterFiles = () => {
    if (searchValue) {
      let files = {}
      Object.values(jsonFiles).forEach((item: any) => {
        if (item?.filename?.startsWith(searchValue)) {
          files = { ...files, [item?.id]: item }
        }
      }
      )
      setFilesList(files)
    } else {
      setFilesList(jsonFiles)
    }

  }

  return (
    <div className="json-wrapper">
      {!loading && uploadLoading && <div className='loading-overlay'>
        <div className='loading-wrapper'>
          <Spin indicator={<Icon type="loading" style={{ fontSize: 44, color: '#15808C' }} spin />} />
        </div>
      </div>}
      <div className="json-header__container">
        <div className="json-header__content-wrapper">
          <div className="header">
            <BackArrow className='backarrow' onClick={handleBackArrowClick} />
            <div className="header-content">
              <div className="header-content--title">{PAGE_TITLE}</div>
              <div className="header-content--subtitle">{PAGE_SUBTITLE}</div>
            </div>
          </div>
          <div className="submit-wrapper">
            <div className='json-search-input'>
              <Input onPressEnter={() => filterFiles()}
                className='search-field'
                placeholder='Search...'
                onChange={(e) => setSearchValue(e.target.value)} value={searchValue}
                prefix={<SearchIcon />}

              />
            </div>
            <div className='layout-icon'>
              {isGridLayout ? <GridIcon title='Grid view' onClick={handleLayoutSwitch} /> : <ListIcon title='List view' onClick={handleLayoutSwitch} />}
            </div>
            <div className="file-input-wrapper">
              <input id="imageInput" type="file" accept="application/json" hidden onChange={handleJsonUpload} />
              <label htmlFor="imageInput" className="add-new-btn">{ADD_NEW_BTN}</label>
            </div>
          </div>
        </div>
      </div>
      <hr />
      <div className="json-body__container" style={{ overflowY: isGridLayout ? "auto" : "hidden" }}>
        {!loading ? <> {isGridLayout ? <div className="body__wrapper--flex">
          {Object.values(filesList).map((item: any) =>
            <JSONFile
              id={item.id}
              setSelectedJsonFile={setSelectedJsonFile}
              key={item.id}
              url={item.url}
              size={item?.size}
              name={item.filename}
              handleJSONFileUrlCopy={handleJSONFileUrlCopy}
              handleJSONFileDelete={handleJSONFileDelete}
              setDeleteModalVisible={(val) => setDeleteModalVisible(val)}
            />)}
        </div> :
          <div className="body__wrapper--list">
            <Table
              pagination={false}
              scroll={{ y: 'calc(100vh - 300px)' }}
              columns={columns}
              className='override-table-container-app'
              dataSource={listView}
            />
          </div>}
        </> : <div style={{ display: "flex", height: "100%", alignItems: "center", justifyContent: "center" }}>
            <Spin indicator={<Icon type="loading" style={{ fontSize: 24, color: '#15808C' }} spin />} />
        </div>
        }

      </div>
      <Modal
        id={selectedJsonFile?.id}
        dataTestId="delete_JsonAsset"
        loading={modalLoading}
        unmountOnCancel={true}
        visible={deleteModalVisibile}
        title="DELETE"
        onCancel={() => {
          setDeleteModalVisible(false)
        }}
        children={<div style={{ padding: "16px 24px 36px 4px", color: "#747474" }}>
          <div >Do you want to remove the</div>
          <div style={{ fontWeight: "bold" }}>{`${selectedJsonFile?.name}?`}</div>
        </div>}
        footer={{
          enable: true,
          okText: "REMOVE",
          cancelText: "CANCEL",
          OkButtonColor: "shadow-secondary",
          onOk: () => {
            handleJSONFileDelete(selectedJsonFile?.name, selectedJsonFile?.id)
          },
        }}
      />
    </div>
  )
}


const JSONFile = ({ id, url, name, size, setSelectedJsonFile, handleJSONFileUrlCopy, handleJSONFileDelete, setDeleteModalVisible }: { id: string, url: string, name: string, size: string, setSelectedJsonFile: (arg: { id: string, name: string }) => void, handleJSONFileUrlCopy: (id: string) => void, handleJSONFileDelete: (filename: string, id: string) => void, setDeleteModalVisible: (arg: boolean) => void }) => {
  return (
    <div className="item" onClick={() => setSelectedJsonFile({ id, name })}>
      <div className="details-wrapper">
        <JsonIcon />
        <div className='filename-wrapper'>
          <div title={name} className="filename">{name}</div>
          <div className="filesize">{FormatBytes(size)}</div>
        </div>
        <div className="more-icon-wrapper">
          <Popover className="relative json-context-popover">
            <Popover.Button className="more-icon-button">
              <MoreElipsis />
            </Popover.Button>

            <Popover.Panel className="json-context-menu absolute z-10">
              {({ close }) => (
                <ul className='more-icon-list'>
                  <li>
                    <button onClick={() => { handleJSONFileUrlCopy(id); close(); }}>
                      <CopyIcon /> Copy Link
                    </button>
                  </li>
                  <li>
                    <button onClick={() => { setDeleteModalVisible(true); close(); }}>
                      <DeleteIcon /> Remove
                    </button>
                  </li>
                </ul>
              )}
            </Popover.Panel>
          </Popover>
        </div>
      </div>

    </div>
  )
}